(() => {
  if (window.allDayEnamelSupportInitialized) return;

  window.allDayEnamelSupportInitialized = true;

  const rootSelector = '[data-all-day-enamel-support]';
  const tabSelector = '[data-all-day-tab]';

  const activateTab = (root, activeTab, moveFocus = false) => {
    const tabs = [...root.querySelectorAll(tabSelector)];
    const panels = root.querySelectorAll('[data-all-day-panel]');
    const activeName = activeTab.dataset.allDayTab;

    tabs.forEach((tab) => {
      const isActive = tab === activeTab;

      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.allDayPanel !== activeName;
    });

    if (moveFocus) activeTab.focus();
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(tabSelector);
    const root = tab?.closest(rootSelector);

    if (!tab || !root) return;

    activateTab(root, tab);
  });

  document.addEventListener('keydown', (event) => {
    const currentTab = event.target.closest(tabSelector);
    const root = currentTab?.closest(rootSelector);

    if (!currentTab || !root) return;

    const tabs = [...root.querySelectorAll(tabSelector)];
    const currentIndex = tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      activateTab(root, tabs[nextIndex], true);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(rootSelector);
    const selectedTab = [...(root?.querySelectorAll(tabSelector) ?? [])].find(
      (tab) => tab.dataset.allDayTab === event.detail?.blockId,
    );

    if (root && selectedTab) activateTab(root, selectedTab);
  });
})();
